export default __webpack_public_path__ + "static/media/swift.daeb9c9b.svg";